<template>
  <div class="PageBox">
    <div class="ScrollBox">
      <van-tabs :border="false" color="#dd6161" title-active-color="#fff" title-inactive-color="#991d35" line-width="50" v-model="tabsIndex" @change="changeTabs">
        <van-tab v-for="item in taskTabs" :title="item.text" :key="item.state" style="padding: 0 12px;">
          <van-pull-refresh v-model="isRefresh" @refresh="onRefresh">
            <!-- <van-list
                v-model="isLoad"
                :finished="isFinished"
                :finished-text="listData.length?'$t('newlist.placeholder[0]')':'$t('newlist.placeholder[1]')'"
                @load="onLoad"
                :class="{Empty:!listData.length}"
            > -->
              <div>
                <div style="text-align:center" v-if="listData.length <= 0" class="no_data">{{$t('newlist.text[0]')}}</div>
				<div v-if="listData.length > 0">
					<van-cell  class="FundItem" :border="false" v-for="(item,index) in listData" :key="item.dan">
					  <template #title>
						<div>
							<span class="money">{{$t('newlist.text[1]')}} : {{ Number(item.money* item.lilv*item.daynum).toFixed(2)}}</span>
						</div>
						<div>
							<span style="color:green">{{item.yuebaoid_name}}{{$t('newlist.text[4]')}} : ({{item.status_label}})</span>
						</div>
						<div>
							<span>{{$t('newlist.text[2]')}} : {{item.money}}</span>
						</div>
						<div>
							<span  style="flex:none">{{$t('newlist.text[3]')}} : {{item.start_time}}</span>
						</div>
						<div>
							<span  style="flex:none">{{$t('newlist.text[5]')}} : {{item.end_time}}</span>
						</div>
					  </template>
					</van-cell>
				</div>
              </div>
            </van-list>
          </van-pull-refresh>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
export default {
  name: 'newlist',
  components: {
  },
  props: [],
  data() {
    return {
      listData: '',
      isLoad: false,
      isFinished: false,
      isRefresh: false,
      pageNo: 1,
      tabsState: 4,
      tabsIndex: 0,
      taskTabs: [
		{state: 1, text: this.$t('task.tabs[0]')},
		// {state: 2, text: this.$t('task.tabs[1]')},
		{state: 3, text: this.$t('task.tabs[2]')},
		// {state: 4, text: this.$t('task.tabs[3]')},
		// {state: 5, text: this.$t('task.tabs[4]')},
		// {state: 6, text: this.$t('task.tabs[5]')}
      ],
    }
  },
  computed: {

  },
  watch: {
    $route(){
      if(this.fundState){
        this.tabsIndex  = this.taskTabs.findIndex(item=>item.state==this.fundState)
        this.tabsState = this.fundState
      }else{
        this.tabsState = 4
        this.tabsIndex = 0
      }
      this.getListData('init')
    }
  },
  created() {
    this.$parent.navBarTitle = this.$t("newlist.i18n[0]")
    this.listData = this.taskTabs.flatMap(item=>[''])
    if(this.fundState){
      this.tabsIndex  = this.taskTabs.findIndex(item=>item.state==this.fundState)
      this.tabsState = this.fundState
    }
    switch(this.fundState){

    }
    this.getListData('init')
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {

  },
  methods: {
    onLoad() {
      this.getListData('load')
    },
    changeTabs(index) {
		if(this.tabsIndex==0){
			this.getnewList(1);
		}else{
			this.getnewList(2);
		}
    },
    getListData(type) {
      this.isLoad = true
      this.isRefresh = false
      if(type=='load'){
        this.pageNo+=1
      }else{
        this.pageNo = 1
        this.isFinished = false
      }
      this.getnewList(1);
    },
	getnewList(status){
		this.$Model.newList({userid:JSON.parse(localStorage.getItem("UserInfo")).userid,status:status},data=>{
		    this.isLoad = false
		    this.listData = data.info
		})
	},
    onRefresh() {
      this.getListData('init')
    },
  }
}
</script>
<style scoped>
.van-tabs ::v-deep .van-tab {
    padding: 0 10px;
    vertical-align: middle;
    height: 100%;
    min-width: 5.5rem;
    border-right: 1px solid #37774C;
}
.van-tabs ::v-deep .van-tabs__wrap {
    width: 70%;
    margin: 0 auto;
    margin-top: 0.9375rem;
    border-radius: 30px;
    border: 1px solid #37774C;
}
.van-tabs ::v-deep .van-tab--active {
    background: #37774C;
    height: 100%;
}
.van-pull-refresh{
  min-height: calc(100vh - 90px);
}
.no_data:before{
	content: "";
	height: 8rem;
	display: block;
	background: url(/static/img/no_data.ceea4cc8.png) no-repeat center 0;
	background-size: contain;
	margin-top: 40%;
}
.no_data{
	color: #969799;
	font-size: 14px;
	line-height: 50px;
	text-align: center;
}
.FundItem{
	margin: 0;
}
.FundItem .van-cell__title{
	padding: 10px 20px;
	box-shadow: 0px 4px 6px 0px rgb(52 46 56 / 46%);
	border-radius: 0.625rem;
}
.FundItem .van-cell__title>div{
	line-height: 28px;
}
.FundItem .van-cell__title>div:last-child{
	margin-top: 0;
}
.FundItem .van-cell__title>div span:last-child{
	text-align: left;
}

</style>